import React, { useState } from 'react';

import { makeStyles, Typography } from '@material-ui/core';

import { useSearchQuery } from 'contexts/SearchQueryContext';
import parseTextToHtml from 'utils/parseTextToHtml';

const LIMIT_READ_MORE = 512; // limite de 512 caracteres para exibir "ler mais"

const useStyles = makeStyles(({ palette, spacing }) => ({
  readMoreButton: {
    paddingLeft: spacing(0.5),
    fontWeight: 500,
    color: palette.text.secondary,

    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
}));

interface ReadMoreParsedTextProps
  extends Omit<
    React.ComponentProps<typeof Typography>,
    'dangerouslySetInnerHTML' | 'children'
  > {
  texto: string;
  maxLength?: number;
}

export default function ReadMoreParsedText({
  texto,
  maxLength = LIMIT_READ_MORE,
  ...props
}: ReadMoreParsedTextProps) {
  const classes = useStyles();
  const searchQuery = useSearchQuery();
  const [expanded, setExpanded] = useState(false);

  const textoCompleto = parseTextToHtml(texto, searchQuery);
  const textoTruncado = textoCompleto.slice(0, maxLength).trim();

  return (
    <>
      <Typography
        {...props}
        component="span"
        dangerouslySetInnerHTML={{
          __html:
            expanded || textoCompleto.length <= LIMIT_READ_MORE
              ? textoCompleto
              : `${textoTruncado}...`,
        }}
      />
      {!expanded && textoCompleto.length > LIMIT_READ_MORE && (
        <Typography
          {...props}
          component="span"
          onClick={() => setExpanded(true)}
          className={classes.readMoreButton}
        >
          Ler mais
        </Typography>
      )}
    </>
  );
}
